export const ASSET_VIEW_BASE_EVENT = `asset:views`;

export enum AssetViewEvent {
	INIT = `${ASSET_VIEW_BASE_EVENT}:init`,
	INITIALIZED = `${ASSET_VIEW_BASE_EVENT}:initialized`,
	EXTEND = `${ASSET_VIEW_BASE_EVENT}:extend`,

	UPLOAD = `${ASSET_VIEW_BASE_EVENT}:upload`,
	EDIT = `${ASSET_VIEW_BASE_EVENT}:edit`,
	REPLACE = `${ASSET_VIEW_BASE_EVENT}:replace`,
}
